import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export const VIP_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/VIPCustomComponent.json' as const;
export const VIP_COMPONENT_TYPE = 'Vip' as const;

export const VIP_ACTIONS = {
  ADD: 'vip_add',
  EDIT: 'vip_edit',
} as const;

export const VIP_SCREENS = [VIP_ACTIONS.ADD, VIP_ACTIONS.EDIT];

export const VIP_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    { navigatedFrom: VIP_ACTIONS.ADD, animationType: ANIMATION_TYPES.OVERLAY_VIEW },
    { navigatedFrom: VIP_ACTIONS.EDIT, animationType: ANIMATION_TYPES.OVERLAY_VIEW },
  ],
  [VIP_ACTIONS.ADD]: [{ navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS, animationType: ANIMATION_TYPES.OVERLAY_VIEW }],
  [VIP_ACTIONS.EDIT]: [{ navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS, animationType: ANIMATION_TYPES.OVERLAY_VIEW }],
};
